// Mantido à mão. Não rodar ./bin/rails stimulus:manifest:update: ele reescreveria os controllers
// carregados sob demanda (lazyLoadControllers, no fim) como imports estáticos, e eles voltariam
// para o bundle principal. Controller novo e leve: import + register aqui; pesado: lá embaixo.

import { application } from "./application"
import { lazyLoadControllers } from "./lazy"
import AdsenseController from "./adsense_controller"
import CopyArticleAddressController from "./copy_article_address_controller"
import PushController from "./bridge/push_controller";
import RemoteModalController from "./remote_modal_controller";
import ShareController from "./bridge/share_controller";
import SwiperController from "./swiper_controller";
import WebradioController from "./bridge/webradio_controller";
import GalaLightboxController from "./gala_lightbox_controller";
import GuiaLocationController from "./guia_location_controller";
import AdminSidebarController from "./admin_sidebar_controller";
import GuiaBusinessPreviewController from "./guia_business_preview_controller";
import GuiaTranslateController from "./guia_translate_controller";
import GooglePlacesController from "./google_places_controller";
import AgendaFieldController from "./agenda_field_controller";
import GuiaLocationBridgeController from "./bridge/guia_location_controller";
import NavLogoBridgeController from "./bridge/nav_logo_controller";
import NavDarkBridgeController from "./bridge/nav_dark_controller";
import PartnerTranslationController from "./partner_translation_controller";
import PhoneMaskController from "./phone_mask_controller";
import PostEmbedsController from "./post_embeds_controller";
import PublishWizardController from "./publish_wizard_controller";
import CharCounterController from "./char_counter_controller";
import SharePreviewController from "./share_preview_controller";
import HighlightPreviewController from "./highlight_preview_controller";
import AiPollController from "./ai_poll_controller";
import AiSuggestionController from "./ai_suggestion_controller";
import PostReadController from "./post_read_controller";
import AutoSubmitController from "./auto_submit_controller";
import SubmitFormController from "./submit_form_controller";

application.register("adsense", AdsenseController);
application.register("agenda-field", AgendaFieldController);
application.register("guia-location-bridge", GuiaLocationBridgeController);
application.register("nav-logo-bridge", NavLogoBridgeController);
application.register("nav-dark-bridge", NavDarkBridgeController);
application.register("admin-sidebar", AdminSidebarController);
application.register("guia-business-preview", GuiaBusinessPreviewController);
application.register("guia-translate", GuiaTranslateController);
application.register("google-places", GooglePlacesController);
application.register("copy-article-address", CopyArticleAddressController);
application.register("push", PushController);
application.register("remote-modal", RemoteModalController);
application.register("share", ShareController);
application.register("swiper", SwiperController);
application.register("webradio", WebradioController);
application.register("gala-lightbox", GalaLightboxController);
application.register("guia-location", GuiaLocationController);
application.register("partner-translation", PartnerTranslationController);
application.register("phone-mask", PhoneMaskController);
application.register("post-embeds", PostEmbedsController);
application.register("publish-wizard", PublishWizardController);
application.register("char-counter", CharCounterController);
application.register("share-preview", SharePreviewController);
application.register("highlight-preview", HighlightPreviewController);
application.register("ai-poll", AiPollController);
application.register("ai-suggestion", AiSuggestionController);
application.register("post-read", PostReadController);
application.register("auto-submit", AutoSubmitController);
application.register("submit-form", SubmitFormController);

// Os pesados (React, editores, gráficos, galeria) ficam fora do bundle principal: cada um é um
// chunk que só desce quando a página tem um elemento com aquele data-controller.
lazyLoadControllers(application, {
  "chartkick": () => import("./chartkick_controller"),
  "gala-dropzone": () => import("./gala_dropzone_controller"),
  "image-editor": () => import("./image_editor_controller"),
  "lightbox": () => import("@stimulus-components/lightbox"),
  "photo-uploader": () => import("./photo_uploader_controller"),
  "player-topbar": () => import("./player_topbar_controller"),
  "select2": () => import("./select2_controller"),
  "tiptap-editor": () => import("./tiptap_editor_controller"),
  "trix": () => import("./trix_controller"),
});
